export default function (Vue) {
  Vue.mixin({
    computed: {
      otzarVersion() {
        try {
          return parseInt(this.$store.state.otzar_version);
        } catch {
          return 0;
        }
      },
    },
  });
}
